// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-xl{border-radius:1.25rem!important}.d-flex.items-flex-grow>*{flex-basis:0;flex-grow:1;max-width:100%}.dp-modal-footer-stacked>:not(:first-child){margin-left:0;margin-bottom:1rem}", ""]);
// Exports
module.exports = exports;
